import { useParams } from 'react-router-dom'

export default function useAdminLink() {
  const { lang } = useParams()

  return (path) => {
    if (lang && ['en', 'es'].includes(lang)) {
      return `/${lang}${path}`
    }
    return path
  }
}
